module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9"
    }
  }, [_c('span', {
    staticClass: "dash"
  }, [_vm._v("INTRODUCTION")])])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "introh"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9"
    }
  }, [_c('strong', [_vm._v("Welcome"), _c('br'), _vm._v("to"), _c('br'), _vm._v("Knitting!")])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10"
    }
  })]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10"
    }
  }), _c('div', {
    staticClass: "pagebreak"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "introh"
  }, [_c('strong', [_vm._v("Why"), _c('br'), _vm._v("Knitting?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are so many reasons to learn to knit. Maybe you’ve been in search of a hobby, an activity to keep your hands busy with something other than scrolling mindlessly through your phone or picking at your nails on your daily commute. Something more outwardly focused than meditation but more inward than watching movies; lower impact than exercise; cheaper and healthier than a vat of red wine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe you find yourself needing a process that’s tangible, one that involves taking little more than sticks and string, adding time and effort, and ending with a real, useful object.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10"
    }
  }, [_vm._v("Maybe the older you get, the more you realize it’s been a really long time since you’ve learned something new, and figure you should give being a beginner a try again, with exceptionally low stakes. Maybe you feel like it’s time to just suck at something for a little while.")]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11"
    }
  })]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Or maybe you just really want a hat!")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11"
    }
  }, [_vm._v("Whatever your reasoning—and there are infinitely more options than I’ve mentioned—wanting to learn to knit means you’re already well on your way there. You might think you’re not “crafty” or capable of wrapping your brain around it, but I can assure you that in my ten-odd years of teaching knitting to other people, I’ve had more students than I can count who make the exact same claim and walk away from their first (sometimes second) lesson with an honest-to-God piece of fabric. It might be a little crooked, it might not yet be a scarf or a hat, it might not look like something you’d see on Instagram or pick up in a clothing store, but it’s the essential building block for everything that’s to come. I promise that whether you’re left- or right-handed, an experienced maker of things or a total klutz, you are more than capable of getting there too.")]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12"
    }
  })]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12"
    }
  }), _c('div', {
    staticClass: "pagebreak"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "introh"
  }, [_c('strong', [_vm._v("Why a"), _c('br'), _vm._v("Hat?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Eventually, of course, you’ll want that scrap of fabric, or one like it, to actually become a thing. The most popular such item, in knitting lessons and lore, is a scarf.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This makes a lot of sense on the surface. A scarf is the easiest beginner project to knit inasmuch as to make the most basic scarf, all you need to learn is to cast on (we’ll get to that), to do the knit stitch (that too), and to cast off (I would never leave you hanging).")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12"
    }
  }, [_vm._v("A scarf is essentially a long practice swatch, and therein lies the problem—a scarf can be very, very long. For some beginners, this is a good thing; performing the same motion over and over again gets them in the correct rhythm, helps them improve and troubleshoot their own work as they go, and generally feels soothing.")]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13"
    }
  })]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("For many others, though, repetition is the kiss of death. They start off with great enthusiasm, but by the time they’ve reached inch ten or so, they begin to wonder precisely how much longer they’ll have to do the exact same thing. They’ll zone out and drop a stitch or two, which is not a stumbling block on its own but, when it’s the result of boredom, is a symptom of a far worse condition. They’ll put the project aside for a couple of days that turn into a couple of months that turn into “oh yeah, I tried to knit once, but it just wasn’t for me.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13"
    }
  }, [_vm._v("This is why, whenever possible, I direct new knitters to try a hat for their first project. This isn’t to say that you have to dive in headfirst (ha!)—we’ll go over the motions of knitting before setting our sights on the full undertaking—but it "), _c('em', [_vm._v("is")]), _vm._v(" to say that you’ll be a little more challenged than your scarf-knitting counterparts. Making something round, something that requires decreases, is necessarily a tad harder than just going back and forth, but it’s the kind of difficulty that you’ll learn from. Once you’ve made a hat, you’ll be well set up to make projects you’ve likely never dared to think about—infinity scarves, sweaters, even socks. Those essential building blocks of knitting that add up to an intricate, lacy top aren’t really any different from the ones that will make up your simple, solid hat.")]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14"
    }
  })]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14"
    }
  }), _c('div', {
    staticClass: "pagebreak"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "introh"
  }, [_c('strong', [_vm._v("It Will Be"), _c('br'), _vm._v("Wonky")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Still, I understand the fear that creeps in with starting anything new, particularly as an adult. We’re taught that we’re supposed to be automatically good at whatever we try, and that if we’re not, we should abandon it and spend our time doing something else.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14"
    }
  }, [_vm._v("But I’d like to argue in favor of being bad at an activity, at least at the beginning; it’s not an indictment of you or your worth, and it doesn’t mean that you’re not “crafty” or will never be able to master a given technique. In fact, it can be good to surrender to the process, to "), _c('em', [_vm._v("not")]), _vm._v(" feel like you have to be totally in control at any given moment. And if your first couple of rows, or even your first couple of projects, turn out a little wonky, it’s not the end of the world. You can always undo the stitches (we’ll go over how to do that) and reuse the ")]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15"
    }
  }, [_vm._v("yarn, or keep the item as a testament to where you started and, later on, how far you’ve come.")])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15"
    }
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0015-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption')])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15"
    }
  }, [_vm._v("Ultimately, though, you’ll never have a hat until you commit to starting and to sticking with it. And the chances are good that you or someone in your orbit could use one.")]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16"
    }
  })]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16"
    }
  })])])])]), _c('a', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5dde904","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 75
// module chunks = 0